

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { APP_RUTAS } from './app.routes';

const routes: Routes = APP_RUTAS

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true})],
  // imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
